import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";

function FormCheckBoxMultiContainerPreview({ children, ...props }) {
  return <BasePreview {...props}>
    <div>
      {children}
    </div>
  </BasePreview>
}

export default define('form-checkbox-multi-container', FormCheckBoxMultiContainerPreview, Fragment)
  .shared(prop.share('FormCheckboxMultiContainer', 'form-checkbox-multi-container'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    textAlign: {
      vertical: 'middle',
    },
  })
  .build()

